/**
 * Extracts the first value from an async generator.
 * Throws an error if the generator is exhausted.
 *
 * @param iterable - The async generator to get the first value from
 * @returns A promise that resolves to the first value
 * @throws Error if the generator has no elements
 *
 * @example
 * ```ts
 * import { First } from "@pdfking/tfunc"
 *
 * async function* generateNumbers() {
 *   for (let i = 0; i < 10; i++) {
 *     yield i;
 *   }
 * }
 *
 * const gen = generateNumbers();
 * const firstValue = await First(gen); // 0
 * const secondValue = await First(gen); // 1
 * ```
 */
export const First = async <T>(iterable: AsyncGenerator<T>): Promise<T> => {
  const { done, value }: IteratorResult<T> = await iterable.next()

  if (done) throw new Error("No elements in iterable")

  return value
}
